module.exports = __webpack_public_path__ + "img/20180109_170822-min.1e31dea6.jpg";